import { ChevronDown } from 'lucide-react'

export function FilterTriggerButton({
  label,
  onClick,
  testId,
}: {
  label: string
  onClick: () => void
  testId?: string
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className="inline-flex min-h-11 max-w-full items-center gap-1.5 rounded-full border border-border bg-card px-3 py-2 text-sm font-medium text-foreground"
    >
      <span className="truncate">{label}</span>
      <ChevronDown className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
    </button>
  )
}
